/**
 * Validates a password against security criteria.
 * @param {string} password - The password to validate.
 * @returns {object} - An object containing the validation results for each criterion.
 */
export const validatePassword = (password) => {
  const p = password || '';
  return {
    length: p.length >= 8,
    uppercase: /[A-Z]/.test(p),
    lowercase: /[a-z]/.test(p),
    number: /[0-9]/.test(p),
    special: /[^A-Za-z0-9]/.test(p)
  };
};

/**
 * Checks if all password criteria are met.
 * @param {object} criteria - The criteria object returned by validatePassword.
 * @returns {boolean} - True if all criteria are met, false otherwise.
 */
export const isPasswordSecure = (criteria) => {
  return Object.values(criteria).every(Boolean);
};
